import { useState } from 'react'
import { useFormsStore } from '../../../../stores/onboarding'
import { usePersonalStore } from '../../../../stores/personalInfo';
import { useInitializeStore } from '../../../../stores/initialize';
import Toast from 'react-native-toast-message'
import { globalStyles } from '../../../../static/styles/global';
import { ActivityIndicator, ScrollView, View } from 'react-native';
import HomeDetailsHeader from '../../../home/HomeDetailsHeader';
import Card from '../../../shared/card/Card';
import CustomButton from '../../../shared/button/Button';
import Canvas from '../../../canvas';
import moment from 'moment';
import { Text } from 'react-native';

const Operations = ({ navigation, route }) => {



    const { essUserOnBoardingKey, essUserOnBoardingFormKey, essFormKey } = route.params

    const { loading, postredmondoperations, downloadFile } = useFormsStore();
    const [hasDrawn, setHasDrawn] = useState(false);
    const [signatureDataURL, setSignatureDataURL] = useState('')
    const personalstore = usePersonalStore();
    const intializestore = useInitializeStore()
    const data = {
        completeOnline: true,
        essUserKey: intializestore.initializeData.userkey,
        entityId: personalstore.personalData?.entityId,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        essObKey: essUserOnBoardingKey,
        sign: signatureDataURL
    }

    const handlesubmit = async () => {

        const response = await postredmondoperations(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel='Forms'
                        navScreen='OnboardingForms'
                        title='Redmonds Operations'
                    />

                </View>
                <Text style={{ textAlign: "center", fontWeight: 'bold', textDecorationLine: 'underline', color: 'lightblue' }} onPress={() => { downloadFile(essFormKey) }}>View Instructions Here</Text>
            </View>
            <ScrollView>
                <Card style={{
                    fontFamily: "Arial, sans-serif",
                    lineHeight: "1.6", fontSize: "11px",
                }}>
                    <h3 style={{ fontWeight: "bold" }}>
                        Grocery Store Operations Policies Acknowledgement
                    </h3>
                    <p>
                        I hereby acknowledge receipt of the Grocery Store Operations Policies. I
                        understand and agree that it is my responsibility to read and comply with
                        the store policies.
                    </p>
                    <p>
                        I hereby understand that if my cash register drawer is “short” for any
                        reason, payroll deduction to offset the shortage will be made from my
                        paycheck for the next three pay periods following the date the shortage is
                        discovered.
                    </p>

                    <div style={{ marginTop: "60px" }}>
                        <div style={{ fontWeight: "bold", fontSize: "11px" }} id="employeeName">
                            {personalstore?.personalData?.firstName} {personalstore?.personalData?.middleInitial} {personalstore?.personalData?.lastName}
                        </div>
                        <div
                            style={{
                                width: "180px", borderBottom: "1px solid #000", marginBottom: "5px"
                            }}
                        ></div>
                        <div style={{ fontSize: "14px", color: "#000" }}>Employee’s Name in Print</div>
                    </div>
                    <div style={{ marginTop: "60px" }}>
                        <div style={{ fontWeight: "bold", fontSize: "11px" }} id="employeeName">
                            <Canvas setSignatureDataURL={setSignatureDataURL} setHasDrawn={setHasDrawn} hasDrawn={hasDrawn} />
                        </div>
                        <div style={{ fontSize: "14px", color: "#000" }}>Signature of Employee</div>
                    </div>

                    <div style={{ marginTop: "60px" }}>
                        <div style={{ fontWeight: "bold", fontSize: "11px" }} id="employeeName">
                            {moment().format("MM/DD/YYYY")}
                        </div>
                        <div
                            style={{
                                width: "180px", borderBottom: "1px solid #000", marginBottom: "5px"
                            }}
                        ></div>
                        <div style={{ fontSize: "14px", color: "#000" }}>Date Signed by Employee</div>
                    </div >

                </Card >
                {loading ? <ActivityIndicator /> :
                    <View style={{ marginTop: 10, marginBottom: 25, flexDirection: 'row', justifyContent: "space-between" }}>
                        <CustomButton
                            text={'Previous'}
                            color={'warn'}
                            onPress={() => navigation.navigate('OnboardingForms')
                            }
                        />
                        <CustomButton
                            isDisabled={!signatureDataURL || !hasDrawn}
                            text={'Submit'}
                            onPress={handlesubmit}
                        />
                    </View>}

            </ScrollView >
        </>
    )
}

export default Operations
